import { useCallback, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ChatSurface from "./ChatSurface";

// Chat dạng modal đè lên trang ERP đang mở (trang nền vẫn render nhờ backgroundLocation
// ở routes/index.js). Panel neo mép phải, mặc định 50% bề ngang, phóng to thì full màn hình.
const ChatModal = ({ background }) => {
  const navigate = useNavigate();
  const panelRef = useRef(null);

  // Đóng modal = quay về đúng URL trang nền. KHÔNG dùng navigate(-1): mở một hội thoại đã đẩy
  // thêm một entry (/app/chat-erp/:conversationId) nên lùi 1 bước chỉ về lại danh sách chat.
  const handleClose = useCallback(() => {
    if (background) navigate(background.pathname + background.search + background.hash);
    else navigate(-1);
  }, [background, navigate]);

  // Khoá cuộn dọc của trang ERP phía sau khi modal mở (đúng như antd Modal làm).
  // Bù padding đúng bề rộng thanh cuộn vừa mất để layout nền không giật ngang.
  useEffect(() => {
    const { body } = document;
    const prevOverflow = body.style.overflow;
    const prevPaddingRight = body.style.paddingRight;
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;

    body.style.overflow = "hidden";
    if (scrollBarWidth > 0) {
      const currentPadding = parseFloat(window.getComputedStyle(body).paddingRight) || 0;
      body.style.paddingRight = `${currentPadding + scrollBarWidth}px`;
    }

    return () => {
      body.style.overflow = prevOverflow;
      body.style.paddingRight = prevPaddingRight;
    };
  }, []);

  // Chat portal các overlay của nó ra body với `position:fixed; inset:0` -> chúng căn giữa theo
  // VIEWPORT, trong khi chat chỉ chiếm nửa phải màn hình. Đo mép trái panel rồi đẩy vào biến CSS
  // để override.css kéo các overlay đó về đúng vùng chat (xem quy tắc --med-chat-panel-left).
  useEffect(() => {
    document.body.classList.add("med-chat-modal-open");

    const updatePanelLeft = () => {
      const el = panelRef.current;
      if (!el) return;
      const { left } = el.getBoundingClientRect();
      document.documentElement.style.setProperty("--med-chat-panel-left", `${left}px`);
    };

    updatePanelLeft();
    // Đo lại sau khi transition width (240ms) chạy xong, vì lúc bấm phóng to bề rộng đang đổi dần.
    const timerId = window.setTimeout(updatePanelLeft, 280);
    window.addEventListener("resize", updatePanelLeft);

    return () => {
      window.clearTimeout(timerId);
      window.removeEventListener("resize", updatePanelLeft);
      document.body.classList.remove("med-chat-modal-open");
      document.documentElement.style.removeProperty("--med-chat-panel-left");
    };
  }, []);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") handleClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [handleClose]);

  return (
    <div
      onClick={handleClose}
      // z-index nằm ở .erp-chat-modal-overlay (override.css) để cả thang chat
      // được khai báo một chỗ - KHÔNG đặt lại zIndex inline ở đây.
      className="erp-chat-modal-overlay"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.45)",
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      {/* Chặn click lọt xuống lớp phủ -> bấm trong panel không bị đóng modal */}
      <div
        ref={panelRef}
        className="chat-page-slide-in"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          height: "100%",
          background: "#fff",
          boxShadow: "-8px 0 24px rgba(15, 23, 42, 0.18)",
        }}
      >
        <ChatSurface onClose={handleClose} />
      </div>
    </div>
  );
};

export default ChatModal;
